import Avatar from '@mui/material/Avatar';
import React from 'react';
import { Box } from '@mui/material';

/** Matches Header `ButtonsStyle` so the logo sits squarely inside the profile control */
const avatarSizeSx = {
  width: { xl: 38, lg: 38, md: 38, sm: 32, xs: 32 },
  height: { xl: 38, lg: 38, md: 38, sm: 32, xs: 32 },
  minWidth: { xl: 38, lg: 38, md: 38, sm: 32, xs: 32 },
  minHeight: { xl: 38, lg: 38, md: 38, sm: 32, xs: 32 },
  maxWidth: { xl: 38, lg: 38, md: 38, sm: 32, xs: 32 },
  maxHeight: { xl: 38, lg: 38, md: 38, sm: 32, xs: 32 },
};

const logoWrapperSx = {
  ...avatarSizeSx,
  borderRadius: '50%',
  overflow: 'hidden',
  flexShrink: 0,
  display: 'block',
};

const avatarImgSx = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
  display: 'block',
};

const AvatarGenerator = (props) => {
  let comname = '';
  let comnametwo = '';
  const data = props.companyname
    ? props.companyname?.split(' ')
    : 'Company Name'.split(' ');

  const datatwo = data && data?.map((word) => word[0]);
  comname = datatwo[0] && datatwo[0].toLowerCase();
  const datathree = (datatwo[0] && datatwo[0]) + datatwo[1];
  comnametwo = datathree;

  let avatarBg = '#445FD2';
  if (
    comname === 'b' ||
    comname === 'e' ||
    comname === 'h' ||
    comname === 'k' ||
    comname === 'n' ||
    comname === 'q' ||
    comname === 't' ||
    comname === 'w' ||
    comname === 'x'
  ) {
    avatarBg = 'blue';
  } else if (
    comname === 'c' ||
    comname === 'f' ||
    comname === 'i' ||
    comname === 'l' ||
    comname === 'o' ||
    comname === 'r' ||
    comname === 'u'
  ) {
    avatarBg = 'maroon';
  } else if (
    !(
      comname === 'a' ||
      comname === 'd' ||
      comname === 'g' ||
      comname === 'j' ||
      comname === 'm' ||
      comname === 'p' ||
      comname === 's' ||
      comname === 'v' ||
      comname === 'y' ||
      comname === 'z'
    )
  ) {
    avatarBg = 'orange';
  }


  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      {props?.AvatarUrl ? (
        <Box sx={{...logoWrapperSx, width: props.width || '100%', height: props.height || '100%', minWidth: props.minWidth || '100%', minHeight: props.minHeight || '100%', maxWidth: props.maxWidth || '100%', maxHeight: props.maxHeight || '100%', mx: 'auto', my: 'auto'}}>
          <Box
            component="img"
            src={props.AvatarUrl}
            alt="Avatar"
            sx={avatarImgSx}
          />
        </Box>
      ) : (
        <Avatar sx={{ bgcolor: avatarBg, ...avatarSizeSx }}>{comnametwo}</Avatar>
      )}
    </Box>
  );
};

export default AvatarGenerator;
